import { fade } from '@material-ui/core/styles/colorManipulator';

const styles = (theme) => ({
    colorSwitchBase: {
        '&$colorChecked': {
            color: '#009AD9',
            '& + $colorBar': {
                backgroundColor: '#009AD9'
            }
        }
    },
    colorBar: {},
    colorChecked: {},
    caption: {
        color: 'blue',
        fontweight: 'bold'
    },
    search: {
        position: 'relative',
        borderRadius: 2,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25)
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        color: 'white'
    },

    downArrowIcon: {
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'end',
        [theme.breakpoints.between('md', 'lg')]: {
            marginLeft: -30
        },
        marginLeft: -50,
        color: '#005F9E'
    },
    inputRoot: {
        color: 'inherit',
        width: '100%'
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(10),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 800
        },
        borderBottom: '2px solid white',
        color: 'white'
    },
    gridContainer: {
        paddingBottom: 20
    },
    title: {
        color: '#005F9E',
        marginLeft: 10
    },
    searchBar: {
        marginRight: 10,
        width: 350
    },
    searchBarDark: {
        marginRight: 10,
        width: 350,
        color: '#808080'
    },
    closeIcon: {
        fontSize: '14px',
        cursor: 'pointer'
    },

    closeIconDark: {
        fontSize: '14px',
        cursor: 'pointer',
        color: '#808080'
    },

    searchIcon: {
        display: 'inline-block',
        marginRight: 20,
        cursor: 'pointer',
        color: '#ffffff'
    },

    searchIconDark: {
        display: 'inline-block',
        marginRight: 20,
        cursor: 'pointer',
        color: '#808080'
    },

    newConnection: {
        backgroundColor: '#0194d3 !important',
        color: '#fff',
        borderRadius: 0
    },
    vcPaper: {
        boxShadow: 'unset'
    },
    vcPaperSysAdmin: {
        paddingTop: '40px',
        boxShadow: 'unset'
    },
    infoIcon: {
        color: '#000000de !important',
        '&:hover,&:focus': {
            backgroundColor: 'rgba(0, 0, 0, 0.0)'
        }
    },

    searchIconAlt: {
        color: '000000de'
    },
    clearIcon: {
        color: 'white'
    },
    addConnectionButton: {
        padding: '6px 8px !important'
    },
    chip: { width: '150px', marginRight: 5 },
    providerName: {
        color: '#0194d3',
        fontWeight: 600,
        cursor: 'pointer',
        width: '400px',
        fontFamily: "'Open Sans SemiBold', sans-serif"
    },
    titleBar: {
        fontSize: 21,
        color: '#000000de !important',
        fontWeight: 600,
        marginTop: '0.5rem',
        paddingLeft: 10
    },
    titleBarAlt: {
        color: '#000000de !important',
        paddingLeft: 0
    },
    warningTitle: { marginTop: 20, fontSize: '2.4rem' },
    warningText: { fontSize: '1.2rem' },
    warningPaper: {
        backgroundColor: '#F3F3F7',
        boxShadow: 'unset'
    },
    messagePosition: {
        marginTop: 100
    },
    inline: {
        paddingBottom: 12
    },
    tableHeader: {
        fontWeight: 'bold',
        cursor: 'pointer',
        paddingLeft: '15px',
        zIndex: 100,
        position: 'sticky',
        lineHeight: '3.5rem',
        backgroundColor: '#fff',
        top: 0,
        borderBottom: '1px solid rgb(174, 174, 182)'
    },
    sysAdminLabel: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#ffbe00',
        fontWeight: 600,
        paddingTop: 10
    },
    iconButtonRoot: {
        padding: 12,
        color: '#000000',
        opacity: 0.5,
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    },
    iconButton: {
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    }
});

export default styles;
